import React, { useState, useEffect } from "react";
import { anyNotBlank, notBlank } from "../common/general";
import { useSelector } from "react-redux";
import { getFieldOptions } from "../common/selectors";
import { not } from "ramda";
import { makeStyles } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";

import RichTextEditor from "./RichTextEditor";

const useStyles = makeStyles(theme => ({
  formHelperText: {
    margin: 0,
    fontSize: "0.75rem",
    marginTop: 3,
    textAlign: "left",
    fontFamily: "Nunito,sans-serif",
    fontWeight: 400,
    lineHeight: 1.66,
    color: theme.palette.primary.error,
  },

  label: {
    color: theme.palette.primary.main,
    marginTop: 0,
    marginBottom: 5,
  },
}));

const CustomizableRichTextField = props => {
  const {
    fieldOption,
    defaultLabel,
    hideByDefault = false,
    value,
    onChange,
    error,
    helperText,
    onBlur,
    xs,
    sm,
    md,
    lg,
    params = {},
  } = props;
  const classes = useStyles();

  const fieldOptions = useSelector(getFieldOptions);
  const [showField, setShowField] = useState(true);
  const [label, setLabel] = useState("");
  useEffect(() => {
    if (notBlank(fieldOptions[fieldOption])) {
      const option = fieldOptions[fieldOption];
      setShowField(!option.hidden);

      if (notBlank(option.fieldLabel)) {
        setLabel(option.fieldLabel);
      } else if (notBlank(defaultLabel)) {
        setLabel(defaultLabel);
      } else {
        setLabel("No Label Defined");
      }
    } else {
      setShowField(not(hideByDefault));

      if (notBlank(defaultLabel)) {
        setLabel(defaultLabel);
      } else {
        setLabel("No Label Defined");
      }
    }
  }, [fieldOptions, fieldOption, defaultLabel, hideByDefault, value]);

  const wrapGrid = element => {
    if (anyNotBlank([xs, sm, md])) {
      return (
        <Grid item xs={xs || 12} sm={sm || 6} md={md || 6} lg={lg || 8}>
          <p className={classes.label}>{label}</p>
          {element}
        </Grid>
      );
    } else {
      return element;
    }
  };

  return (
    showField && (
      <Grid container item direction="column">
        {wrapGrid(
          <RichTextEditor
            {...params}
            editable
            onBlur={onBlur}
            onChange={onChange}
            error={error}
            html={value}
          />
        )}
        {helperText && <p className={classes.formHelperText}>{helperText}</p>}
      </Grid>
    )
  );
};

export default CustomizableRichTextField;
